import type { SxStyle } from '@aibees/shared/theme';

const flexColumn: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const root: SxStyle = {
  background: (p) => p.palette.grey[200],
  border: 'none',

  '.MuiTabPanel-root': {
    p: 0,
  },

  '& .MuiTabs-indicator': {
    color: (p) => p.palette.primary[500],
    background: (p) => p.palette.primary[500],
  },

  '& .Mui-selected': {
    color: (p) => p.palette.primary[500],
  },
};

export const title: SxStyle = {
  color: (p) => p.palette.common.black,
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const content: SxStyle = {
  ...flexColumn,
  gap: (p) => p.spacing(1),
  p: (p) => p.spacing(1),
};

export const searchIcon: SxStyle = {
  color: (p) => p.palette.grey[400],
  mr: 0.5,
};

export const tabTitle: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const applyButton: SxStyle = {
  borderRadius: (p) => p.spacing(0.5),
  color: (p) => p.palette.primary[500],
  background: (p) => p.palette.common.white,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[500],
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightMedium,

  '&.Mui-disabled': {
    borderColor: (p) => p.palette.primary[500],
    color: (p) => p.palette.primary[500],
    background: 'transparent',
    opacity: 0.5,
    cursor: 'none',
  },

  '&:hover': {
    color: (p) => p.palette.primary[600],
    background: (p) => p.palette.common.white,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: (p) => p.palette.primary[600],
  },
};

export const cancelButton: SxStyle = {
  color: (p) => p.palette.common.black,
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightMedium,
};

export const cardBox: SxStyle = {
  ...flexColumn,
  px: (p) => p.spacing(1),
  py: 0,
  gap: (p) => p.spacing(1),
};
